import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const usePricing = () => {
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    const override = new URLSearchParams(window.location.search).get('ppp');
    const url = override ? `${API_URL}/api/pricing?country=${override}` : `${API_URL}/api/pricing`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => data && setPricing(data))
      .catch(() => {});
  }, []);

  const getPrice = (planId, type = 'subscriptions', fallback = '') =>
    pricing?.[type]?.[planId]?.display || fallback;

  return {
    pricing,
    getPrice,
    discountPct: pricing?.discount_pct || 0,
    band: pricing?.band || 'A',
    country: pricing?.country || null
  };
};
